import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'button-cancelar-arquivo-concessao',
  templateUrl: './button-cancelar-arquivo-concessao.component.html',
  styleUrls: ['./button-cancelar-arquivo-concessao.component.scss']
})
export class ButtonCancelarArquivoConcessaoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
